import React, { useState, useEffect } from 'react';
import CommonModalLayout from '../Layouts/CommonModalLayout';
import { buttonStyles, inputStyles } from '../../styles/commonStyles';
import { useTranslation } from 'react-i18next';

const EditGroupModal = ({ isOpen, onClose, group, onSave }) => {
    const { t } = useTranslation();
    const [groupName, setGroupName] = useState('');
    const [groupDescription, setGroupDescription] = useState('');

    useEffect(() => {
        setGroupName(group?.name || '');
        setGroupDescription(group?.description || '');
    }, [group]);

    const handleSave = () => {
        if (!groupName.trim()) return;
        onSave({ ...group, name: groupName, description: groupDescription });
        onClose();
    };

    return (
        <CommonModalLayout
            isOpen={isOpen}
            onClose={onClose}
            title={t('categories.editGroup', 'Редактировать группу')}
        >
            <div className="space-y-4">
                <div className="space-y-2">
                    <label htmlFor="groupName" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        {t('categories.groupName', 'Название группы')}
                    </label>
                    <input
                        type="text"
                        id="groupName"
                        value={groupName}
                        onChange={(e) => setGroupName(e.target.value)}
                        className={inputStyles}
                        placeholder={t('categories.groupNamePlaceholder', 'Введите название группы')}
                    />
                </div>
                <div className="space-y-2">
                    <label htmlFor="groupDescription" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        {t('categories.groupDescription', 'Описание (необязательно)')}
                    </label>
                    <textarea
                        id="groupDescription"
                        value={groupDescription}
                        onChange={(e) => setGroupDescription(e.target.value)}
                        className={inputStyles}
                        placeholder={t('categories.groupDescriptionPlaceholder', 'Описание группы')}
                        rows={4}
                    />
                </div>
                <div className="flex justify-end space-x-2">
                    <button
                        onClick={onClose}
                        className={buttonStyles}
                    >
                        {t('common.cancel')}
                    </button>
                    <button
                        onClick={handleSave}
                        className={buttonStyles}
                        disabled={!groupName.trim()}
                    >
                        {t('common.save', 'Сохранить')}
                    </button>
                </div>
            </div>
        </CommonModalLayout>
    );
};

export default EditGroupModal; 